import {APIResponse} from '../APITypes';
import { csrfHeaders } from '../csrf';

export default class CourseEndpoint {
    static async Create(course: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course/create',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(course)
                }
            );
        
        if(!response.ok) {
            throw new Error("Create course failed.");
        }
        return await response.json();
    }

    static async Update(course: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course/update',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(course)
                }
            );
        
        if(!response.ok) {
            throw new Error("Update course failed.");
        }
        return await response.json();
    }

    static async GetAll(): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/course/all',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    }
                }
            );
        
        if(!response.ok) {
            throw new Error("Get all courses failed.");
        }
        return await response.json();
    }
}